import styled from 'styled-components';

export const SectionContainer = styled.div`
  background-color: #1a1a1a;
  padding: 40px 0;
  width: 100%;

  @media (max-width: 768px) {
    padding: 40px 0 56px 0;
  }
`;

export const SectionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 80px;
  max-width: 1369px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0;
    max-width: 340px;
    gap: 30px;
  }

  h1 {
    color: #c3c3c3;
    font-size: 32px;
    font-style: normal;
    font-weight: 275;
    line-height: 40px;

    @media (max-width: 768px) {
      font-size: 18px;
      line-height: 32px;
    }
  }
`;

export const StyledHr = styled.hr`
  flex: 1;
  border: 1px solid #c3c3c3;
`;

export const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  max-width: 1369px;
  width: 100%;
  margin: 80px auto;
  padding: 70px 20px 10px 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    margin: 24px auto 0;
    padding: 0;
    gap: 40px;
  }
`;

export const TextBox1 = styled.div`
  flex: 1;
  padding: 0 40px 0 70px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    max-width: 340px;
    padding: 0px;
  }

  .text-content {
    display: flex;
    flex-direction: column;
    text-align: left;
  }

  p {
    color: #e4e4e4;
    font-size: 48px;
    font-style: normal;
    font-weight: 200;
    line-height: 56px;
    margin: 0;
    padding-left: 10px;
    padding-bottom: 10px;

    @media (max-width: 768px) {
      font-size: 32px;
      line-height: 32px;
      margin-bottom: 40px;
      padding: 0;
    }
  }

  span {
    color: #f16024;
  }
`;

export const TextBox2 = styled.div`
  flex: 1;
  padding: 0px;
  color: #c3c3c3;

  @media (max-width: 768px) {
    max-width: 340px;
    padding: 0px;
  }

  p {
    font-family: 'Open Sans';
    font-size: 20px;
    font-style: normal;
    font-weight: 300;
    line-height: 24px;
    margin-bottom: 10px;

    @media (max-width: 768px) {
      font-size: 16px;
      line-height: 20px;
      margin-bottom: 16px;
    }
  }

  .link-with-icon {
    display: inline-flex;
    align-items: center;
    text-decoration: none;
    gap: 10;
    color: #f16024;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    padding-left: 10px;

    @media (max-width: 768px) {
      max-width: 340px;
      font-size: 16px;
      padding: 0;
      gap: 0;
    }
  }

  .link-with-icon img {
    width: 20px;
    height: 20px;
  }
`;

export const ImageBox = styled.div`
  flex: 1;
  text-align: center;

  img {
    max-width: 100%;
    height: auto;
  }
`;
